export class GestorConviteCadastro {
    public telefone: string;
    constructor(
        public cpf: string,
        public nome: string,
        public email: string,
        public senhaGestor: string,
        public perfisId: number[]
    ) { }
}
